"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// All map related translations
var MapData = {
  map: {
    nl: 'Kaart',
    fr: 'Carte',
    en: 'Map',
    de: 'Karte'
  },
  in_colaberation_with: {
    nl: 'in samenwerking met de lokale besturen',
    fr: 'en collaboration avec Les Pouvoirs Locaux',
    en: 'in collaboration with local authorities',
    de: 'in Zusammenarbeit mit den lokalen Behörden'
  },
  location: {
    nl: 'Locatie',
    fr: 'Emplacement',
    en: 'Location',
    de: 'Ort'
  },
  nis: {
    nl: 'NIS',
    fr: 'INS',
    en: 'NIS',
    de: 'NIS'
  },
  nis_type: {
    nl: 'NIS type',
    fr: 'Type INS',
    en: 'NIS type',
    de: 'NIS-Typ'
  },
  nis_types: {
    nl: 'NIS types',
    fr: 'Types d\'INS',
    en: 'NIS types',
    de: 'NIS-Typen'
  },
  nis_upper: {
    nl: 'Bovenliggende NIS',
    fr: 'Parent INS',
    en: 'NIS parent',
    de: 'Übergeordneter NIS'
  },
  nis_adjacent: {
    nl: 'Aangrenzende NIS',
    fr: 'INS adjacente',
    en: 'Adjacent NIS',
    de: 'Angrenzender NIS'
  },
  alternative_street_translations: {
    nl: 'Alternatieve straat',
    fr: 'Rue alternative',
    en: 'Alternative street',
    de: 'Alternative Straße'
  },
  extra_location_info: {
    nl: 'Extra locatie info',
    fr: 'Extra information sur l\'emplacement',
    en: 'Extra location info',
    de: 'Zusätzliche Standortinformationen'
  },
  extra_info: {
    nl: 'Extra info',
    fr: 'Extra information',
    en: 'Extra info',
    de: 'Zusätzliche Informationen'
  },
  from_nr: {
    nl: 'Van (nr.)',
    fr: 'De (n°)',
    en: 'From (nr.)',
    de: 'Von (Nr.)'
  },
  to_nr: {
    nl: 'Tot (nr.)',
    fr: 'À (n°)',
    en: 'To (nr.)',
    de: 'Bis (Nr.)'
  },
  is_even_nr: {
    nl: 'Even nummer',
    fr: 'Nombre pair',
    en: 'Even number',
    de: 'Gerade Nummer'
  },
  country: {
    nl: 'Land',
    fr: 'Pays',
    en: 'Country',
    de: 'Land'
  },
  flag: {
    nl: 'Vlag',
    fr: 'Drapeau',
    en: 'Flag',
    de: 'Flagge'
  },
  flags: {
    nl: 'Vlaggen',
    fr: 'Drapeaux',
    en: 'Flags',
    de: 'Flaggen'
  },
  coat_of_arms: {
    nl: 'Wapenschild',
    fr: 'Armoiries',
    en: 'Coat of Arms',
    de: 'Wappen'
  },
  region: {
    nl: 'Gewest',
    fr: 'Région',
    en: 'Region',
    de: 'Region'
  },
  regions: {
    nl: 'Gewesten',
    fr: 'Régions',
    en: 'Regions',
    de: 'Regionen'
  },
  province: {
    nl: 'Provincie',
    fr: 'Province',
    en: 'Province',
    de: 'Provinz'
  },
  provinces: {
    nl: 'Provincies',
    fr: 'Provinces',
    en: 'Provinces',
    de: 'Provinzen'
  },
  district: {
    nl: 'Arrondissement',
    fr: 'District',
    en: 'District',
    de: 'Bezirk'
  },
  districts: {
    nl: 'Arrondissementen',
    fr: 'Districts',
    en: 'Districts',
    de: 'Bezirke'
  },
  borders: {
    nl: 'Grenzen',
    fr: 'Frontières',
    en: 'Borders',
    de: 'Grenzen'
  },
  search_municipality: {
    nl: /*#__PURE__*/_react["default"].createElement("p", null, "Zoek een stad / gemeente ", /*#__PURE__*/_react["default"].createElement("br", null), " of selecteer op kaart"),
    fr: /*#__PURE__*/_react["default"].createElement("p", null, "Recherchez une ville / commune ", /*#__PURE__*/_react["default"].createElement("br", null), "ou s\xE9lectionnez sur la carte"),
    en: /*#__PURE__*/_react["default"].createElement("p", null, "Search a city / municipality ", /*#__PURE__*/_react["default"].createElement("br", null), " or select on map"),
    de: /*#__PURE__*/_react["default"].createElement("p", null, "Suchen Sie eine Stadt / Gemeinde ", /*#__PURE__*/_react["default"].createElement("br", null), " oder w\xE4hlen Sie auf der Karte aus")
  },
  wait_loading_map: {
    nl: 'Even geduld, ik haal de kaart voor jou !',
    fr: 'Un instant, je vais chercher la carte pour vous !',
    en: "Hold on, I'm loading the map for you!",
    de: "Moment mal, ich lade die Karte für dich!"
  },
  postal_code: {
    nl: 'Postcode',
    fr: 'Code postal',
    en: 'Postalcode',
    de: 'Postleitzahl'
  },
  postalcode: {
    nl: 'Postcode',
    fr: 'Code postal',
    en: 'Postalcode',
    de: 'Postleitzahl'
  },
  municipality: {
    nl: 'Gemeente',
    fr: 'Commune',
    en: 'Municipality',
    de: 'Gemeinde'
  },
  city: {
    nl: 'Stad',
    fr: 'Ville',
    en: 'City',
    de: 'Stadt'
  },
  municipality_name: {
    nl: 'Gemeentenaam',
    fr: 'Nom de commune',
    en: 'Municipality name',
    de: 'Gemeindename'
  },
  municipality_names: {
    nl: 'Gemeentenamen',
    fr: 'Nom des villes et des communes',
    en: 'Municipality names',
    de: 'Gemeindenamen'
  },
  municipalities: {
    nl: 'Gemeenten',
    fr: 'Municipalités',
    en: 'Municipalities',
    de: 'Gemeinden'
  },
  sub_municipality: {
    nl: 'Deelgemeente',
    fr: 'Sous-municipalité',
    en: 'Sub municipality',
    de: 'Untergemeinde'
  },
  sub_municipalities: {
    nl: 'Deelgemeenten',
    fr: 'Sous-municipalités',
    en: 'Sub municipalities',
    de: 'Untergemeinden'
  },
  neighborhood: {
    nl: 'Wijk',
    fr: 'Quartier',
    en: 'Neighborhood',
    de: 'Nachbarschaft'
  },
  street: {
    nl: 'Straat',
    fr: 'Rue',
    en: 'Street',
    de: 'Straße'
  },
  streets: {
    nl: 'Straten',
    fr: 'Rues',
    en: 'Streets',
    de: 'Straßen'
  },
  streetcode: {
    nl: 'Straat code',
    fr: 'Code de rue',
    en: 'Street code',
    de: 'Straßencode'
  },
  street_name: {
    nl: 'Straatnaam',
    fr: 'Nom de rue',
    en: 'Street name',
    de: 'Straßenname'
  },
  official_street_name: {
    nl: 'Officiële straatnaam',
    fr: 'Nom officiel de la rue',
    en: 'Official street name',
    de: 'Offizieller Straßenname'
  },
  alternative_street_name: {
    nl: 'Alt. straatnaam',
    fr: 'Nom alternatif de la rue',
    en: 'Alt. street name',
    de: 'Alternativer Straßenname'
  },
  street_data: {
    nl: 'Straatdata',
    fr: 'Données de rue',
    en: 'Street data',
    de: 'Straßendaten'
  },
  street_name_id: {
    nl: 'Straatnaam ID',
    fr: 'ID du nom de rue',
    en: 'Street name ID',
    de: 'Straßenname ID'
  },
  streetnmid: {
    nl: 'Straatnaam ID',
    fr: 'ID du nom de rue',
    en: 'Street name ID',
    de: 'Straßenname ID'
  },
  street_code: {
    nl: 'Straat code',
    fr: 'Code de rue',
    en: 'Street code',
    de: 'Straßencode'
  },
  enterance_at: {
    nl: 'Toegang via',
    fr: 'Entrée à',
    en: 'Entrance at',
    de: 'Eingang bei'
  },
  no: {
    nl: 'Nr.',
    fr: 'No.',
    en: 'No.',
    de: 'Nr.'
  },
  box: {
    nl: 'Box Nr.',
    fr: 'Box No.',
    en: 'Box No.',
    de: 'Box Nr.'
  },
  address_info: {
    nl: 'Adres informatie',
    fr: 'Information d\'adresse',
    en: 'Address information',
    de: 'Adressinformationen'
  },
  longitude: {
    nl: 'Lengtegraad',
    fr: 'Longitude',
    en: 'Longitude',
    de: 'Längengrad'
  },
  latitude: {
    nl: 'Breedtegraad',
    fr: 'Latitude',
    en: 'Latitude',
    de: 'Breitengrad'
  },
  current_map_view: {
    nl: 'Huidige kaartweergave:',
    fr: 'Vue actuelle de la carte',
    en: 'Current map view',
    de: 'Aktuelle Kartenansicht'
  },
  view: {
    nl: 'Weergave',
    fr: 'Vue',
    en: 'View',
    de: 'Ansicht'
  },
  map_instructions: {
    nl: "Klik op 1 van de volgende niveaus om een ondernemer, die zijn diensten/producten aanbiedt, terug te vinden. \n            Op (deel)gemeente niveau garanderen wij u een weergave van alle beschikbare ondernemingen. \n            Vanaf provincie niveau gaat het om ondernemingen die commercieel ingeschreven zijn.\n\n            De beschikbare niveaus zijn:",
    fr: "Cliquez sur un des niveaux suivants pour trouver un entrepreneur qui offre ses services/produits. \n            Au niveau des (sous) municipalit\xE9s, nous vous garantissons une repr\xE9sentation de toutes les entreprises disponibles. \n            Au niveau de la province, il s\u2019agit des entreprises inscrites commercialement.\n            \n            Les niveaux disponibles sont:",
    en: "Click on 1 of the following levels to find an entrepreneur who offers his services/products. \n            At (sub) municipality level we guarantee you a representation of all available companies. \n            From the province level, it concerns companies that have signed up commercially.\n            \n            The available levels are:",
    de: "Klicken Sie auf eine der folgenden Ebenen, um einen Unternehmer zu finden, der seine Dienstleistungen/Produkte anbietet. \n            Auf Gemeinde- und Untergemeindeebene garantieren wir Ihnen eine Darstellung aller verf\xFCgbaren Unternehmen. \n            Ab der Provinzebene handelt es sich um Unternehmen, die kommerziell registriert sind.\n\n            Die verf\xFCgbaren Ebenen sind:"
  },
  levels: {
    nl: 'Niveaus',
    fr: 'Niveaux',
    en: 'Levels',
    de: 'Ebenen'
  },
  link_adress: {
    nl: 'Link naar adresinformatie',
    fr: 'Lien vers les informations sur l\'adresse',
    en: 'Link to address information',
    de: 'Link zu Adressinformationen'
  },
  hierarchical_niscode: {
    nl: 'Hiërarchische NIS-code',
    fr: 'Code INS hiérarchique',
    en: 'Hierarchical NIS-code',
    de: 'Hierarchischer NIS-Code'
  },
  historical_niscode: {
    nl: 'Historische NIS-code',
    fr: 'Code INS historique',
    en: 'Historic NIS-code',
    de: 'Historischer NIS-Code'
  },
  country_id: {
    nl: 'Land ID',
    fr: 'ID de pays',
    en: 'Country ID',
    de: 'Land ID'
  },
  nis_type_id: {
    nl: 'NIS-type ID',
    fr: 'ID types INS',
    en: 'NIS-type ID',
    de: 'NIS-Typ ID'
  },
  nis_type_name: {
    nl: 'NIS-type naam',
    fr: 'Nom du type INS',
    en: 'NIS-type name',
    de: 'NIS-Typ Name'
  },
  belgium: {
    nl: 'België',
    fr: 'Belgique',
    en: 'Belgium',
    de: 'Belgien'
  },
  flemish_region: {
    nl: 'Vlaams Gewest',
    fr: 'Région flamande',
    en: 'Flemish Region',
    de: 'Flämische Region'
  }
};
var _default = MapData;
exports["default"] = _default;